import { formatCentsAsDollars, isNotNull } from '@alice-financial/alice-sdk'
import { Box, Grid, SectionHeading, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { WorkLocationList } from '../workLocations/WorkLocationList'
import { OrgSectionProps } from './types'

export const EnrollmentSection = ({ org }: OrgSectionProps) => {
  if (!org) return null
  const isOnboarded = Boolean(org.isOnboarded)

  if (!isOnboarded) return null
  const isPayrollConnected = isOnboarded || Boolean(org.payrollConnection.payrollConnectedAt)

  if (!isPayrollConnected) return null

  const payGroups = org.employers.filter(isNotNull)
  if (payGroups.length === 0) return null

  const { totalSavings } = org.employees

  return (
    <>
      <Box my={4}>
        <SectionHeading gutterBottom>Payroll connection</SectionHeading>
        <Grid container justifyContent="space-between">
          <Grid>
            <Typography variant="body2">
              Payroll provider: <strong>{org.payrollConnection.payrollPlatform?.name}</strong>
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="body2" color="text.secondary">
              <strong>{org.employees.enrolledCount}</strong>/{org.employees.reachableCount} enrolled
            </Typography>
          </Grid>
        </Grid>
        {totalSavings ? (
          <Typography variant="body2" color="primary" gutterBottom>
            <strong>{formatCentsAsDollars(totalSavings)}</strong> total savings
          </Typography>
        ) : null}
      </Box>
      <Box my={4}>
        <WorkLocationList org={org} />
      </Box>
    </>
  )
}
